module.exports = __webpack_public_path__ + "fonts/proximanova-regular-webfont.1405875d.woff";